import { Chip, withStyles } from '@material-ui/core';

export const ModelChipReadOnly = createChipWihFadingBackgroundVariations(
  '#5865E8',
  'rgba(88,101,232,0.10)',
  'rgba(88,101,232,0.05)',
  'rgba(88,101,232,0.15)',
  true,
  true,
);

export function createChipWihFadingBackgroundVariations(
  textColor: string,
  baseColor: string,
  hoverColor: string,
  activeColor: string,
  disableHoverEffect?: boolean,
  disableActiveEffect?: boolean,
): any {
  return withStyles({
    root: {
      background: baseColor,
      color: textColor,
      borderRadius: '5px',
      '&:hover': disableHoverEffect
        ? {}
        : {
            background: hoverColor,
          },
      '&:active': disableActiveEffect
        ? {}
        : {
            background: activeColor,
          },
      '&:disabled': {
        background: '#E2E2E2',
      },
    },
    label: {
      opacity: '1',
    },
  })(Chip);
}
